import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@client.components/Tooltip";
import { CostIndexRuler } from "@client.components/CostIndexValue";
import Icon from "@client.components/Icon";
import GridHeader from "@client.components/GridHeader";

const TimeMeetingParticipantsHeader = (props) => {
  return (
    <GridHeader
      {...props}
      renderExtaElement={() => (
        <Tooltip content={<CostIndexRuler />}>
          <Icon name="info" className="info" />
        </Tooltip>
      )}
    />
  );
};

TimeMeetingParticipantsHeader.propTypes = {
  displayName: PropTypes.string,
  enableSorting: PropTypes.bool,
  column: PropTypes.object,
  setSort: PropTypes.func,
  api: PropTypes.any,
};

export default TimeMeetingParticipantsHeader;
